import { Row, Col, Card, Button, Flex, Tabs } from "antd";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { GET } from "../../../providers/useAxiosQuery";

import ApplicantFormBasicInfo from "./PageApplicantFormComponent/ApplicantFormBasicInfo";
import ApplicantFormExamInfo from "./PageApplicantFormComponent/ApplicantFormExamInfo";
import ApplicantFormPhotoInfo from "./PageApplicantFormComponent/ApplicantFormPhotoInfo";
import ApplicantFormAddressInfo from "./PageApplicantFormComponent/ApplicantFormAddressInfo";
import ApplicantFormHealthInfo from "./PageApplicantFormComponent/ApplicantFormHealthInfo";
import ApplicantFormAccountInfo from "./PageApplicantFormComponent/ApplicantFormAccountInfo";

import ApplicantFormSchoolAttendedInfo from "./PageApplicantFormComponent/ApplicantFormSchoolAttendedInfo";
import ApplicantFormFamilyProfile from "./PageApplicantFormComponent/ApplicantFormFamilyProfile";
import ApplicantFormEmergencyContact from "./PageApplicantFormComponent/ApplicantFormEmergencyContact";
import ApplicantFormAcademicProfile from "./PageApplicantFormComponent/ApplicantFormAcademicProfile";
import ApplicantFormAdditionalInfo from "./PageApplicantFormComponent/ApplicantFormAdditionalInfo";
import ModalProfile from "../PageProfilingPortal/components/ModalProfile";
import ModalAuthPassword from "./components/ModalAuthPassword";

export default function PageApplicantFormContent(props) {
	const {
		form,
		qrCode,
		setFormData,
		examSchedule,
		setExamSchedule,
		toggleModalUploadProfilePicture,
		setToggleModalUploadProfilePicture,
		toggleModalProfile,
		setToggleModalProfile,
		setToggleModalAuthPassword,
		selectedStudentLevel,
		setSelectedStudentLevel,
	} = props;

	const location = useLocation();
	const navigate = useNavigate();
	// const [form] = Form.useForm();

	const [paymentDue, setPaymentDue] = useState();

	const { data: dataCivilStatus } = GET(
		`api/civilstatus`,
		"civilstatus",
		(res) => {},
		false
	);

	const { data: dataNationalities } = GET(
		`api/nationality`,
		"nationality",
		(res) => {},
		false
	);

	const { data: dataReligion } = GET(`api/religion`, "religion");

	const handleStudentLevelChange = (value) => {
		setSelectedStudentLevel(parseInt(value, 10));
	};

	return (
		<>
			<Row gutter={[12, 12]}>
				<Col xs={24} sm={24} md={24} lg={12} xl={12} className="m-0">
					{location.pathname.includes("/profiling-portal") && (
						<Col xs={24} sm={24} md={24} lg={12} xl={12} className="m-0">
							<Flex align="flex-start" vertical>
								<img
									width="400px"
									src="/assets/images/fsuu_logo_v3.png"
									alt="fsuu-logo"
								/>
								<Col xs={24} sm={24} md={24} lg={12} xl={12}>
									<p
										style={{
											width: "320px",
											fontSize: "12px",
											textAlign: "justify",
											color: "#000",
											padding: "10px 20px",
											background: "rgba(90, 90, 90, 0.25)",
										}}
									>
										<strong>Privacy Statement: </strong>
										<em>
											The data provided by the users/applicants is solely used
											for basic profiling and will not be used for any malicious
											purposes.
										</em>
									</p>
								</Col>
							</Flex>
						</Col>
					)}

					{location.pathname.includes("edit") && (
						<Card
							title="Account Information"
							className="card-main-primary account-information"
						>
							<ApplicantFormAccountInfo action="edit" formDisabled={true} />
						</Card>
					)}
				</Col>

				{/* Photo */}
				<Col xs={24} sm={12} md={12} lg={12} xl={12}>
					<Card
						title="Profile Photo"
						className="card-main-primary card-profile-photo"
					>
						<ApplicantFormPhotoInfo
							action="add"
							toggleModalUploadProfilePicture={toggleModalUploadProfilePicture}
							setToggleModalUploadProfilePicture={
								setToggleModalUploadProfilePicture
							}
						/>
					</Card>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Card title="Basic Information" className="card-main-primary">
						<ApplicantFormBasicInfo
							action="edit"
							form={form}
							dataCivilStatus={
								dataCivilStatus && dataCivilStatus.data
									? dataCivilStatus.data
									: []
							}
							dataNationalities={
								dataNationalities && dataNationalities.data
									? dataNationalities.data
									: []
							}
							dataReligion={
								dataReligion && dataReligion.data ? dataReligion.data : []
							}
						/>
					</Card>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Card
						title="Health Information"
						className="card-main-primary disability-info"
					>
						<ApplicantFormHealthInfo form={form} />
					</Card>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Card title="Entrance Exam Information" className="card-main-primary">
						<ApplicantFormExamInfo
							form={form}
							handleStudentLevelChange={handleStudentLevelChange}
							selectedStudentLevel={selectedStudentLevel}
							examSchedule={examSchedule}
							setExamSchedule={setExamSchedule}
							setPaymentDue={setPaymentDue}
						/>
					</Card>
				</Col>

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Flex gap={10} justify="space-between">
						{location.pathname.includes("/profiling-portal/add") && (
							<Button
								variant="outlined"
								size="large"
								onClick={() => navigate("/profiling-portal")}
							>
								<FontAwesomeIcon icon={faArrowLeft} />
								&nbsp;Profiling Portal
							</Button>
						)}

						{location.pathname.includes("/add") && (
							<Button
								type="primary"
								htmlType="submit"
								name="btn_submit"
								size={
									location.pathname.includes("/profiling-portal") ? "large" : ""
								}
							>
								{location.pathname.includes("/profiling-portal")
									? "Submit for Verification"
									: "Submit"}
							</Button>
						)}

						{location.pathname.includes("applicants/walk-in/edit") && (
							<Button
								type="primary"
								className="btn-main-primary mb-20 w-xs-200"
								onClick={() => {
									setFormData(form.getFieldsValue());
									const values = form.getFieldsValue();

									setToggleModalAuthPassword({
										open: true,
										data: values,
									});
								}}
								name="btn_submit"
							>
								Update Changes
							</Button>
						)}

						{location.pathname.includes("/profiling-portal/edit") && (
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Flex justify="space-between">
									<Button
										variant="outlined"
										size="large"
										onClick={() => navigate("/profiling-portal")}
									>
										<FontAwesomeIcon icon={faArrowLeft} />
										&nbsp;Profiling Portal
									</Button>

									<Button
										type="primary"
										htmlType="submit"
										className="btn-main-primary w-xs-200"
										name="btn_submit"
										size="large"
										// onClick={() => {
										// 	setFormData(form.getFieldsValue());
										// 	const values = form.getFieldsValue();

										// 	setToggleModalAuthPassword({
										// 		open: true,
										// 		data: values,
										// 	});
										// }}
									>
										Update Information
									</Button>
								</Flex>
							</Col>
						)}
					</Flex>
				</Col>

				{location.pathname.includes("/applicants/walk-in/edit") && (
					<Col sm={24} md={24} lg={24} xl={24} xxl={24}>
						<Tabs
							className="TABS"
							type="card"
							defaultActiveKey="1"
							items={[
								{
									label: "Student Address",
									key: "1",
									children: (
										<ApplicantFormAddressInfo action="edit" form={form} />
									),
								},
								{
									label: "School Attended",
									className: "tab-item-school-attended-info",
									key: "2",
									children: (
										<ApplicantFormSchoolAttendedInfo
											action="edit"
											form={form}
											handleStudentLevelChange={handleStudentLevelChange}
											selectedStudentLevel={selectedStudentLevel}
										/>
									),
								},
								{
									label: "Family Profile",
									key: "3",
									children: (
										<ApplicantFormFamilyProfile action="edit" form={form} />
									),
								},
								{
									label: "Emergency Contact",
									key: "4",
									children: (
										<ApplicantFormEmergencyContact action="edit" form={form} />
									),
								},
								{
									label: "Academic Profile",
									key: "5",
									children: (
										<ApplicantFormAcademicProfile action="edit" form={form} />
									),
								},
								{
									label: "Additional Information",
									key: "6",
									children: (
										<ApplicantFormAdditionalInfo action="edit" form={form} />
									),
								},
							]}
						/>
					</Col>
				)}
			</Row>

			<ModalProfile
				toggleModalProfile={toggleModalProfile}
				setToggleModalProfile={setToggleModalProfile}
				qrCode={qrCode}
				paymentDue={paymentDue}
			/>
		</>
	);
}
